// extracted by mini-css-extract-plugin
export var footer = "_ma-5";
export var fulfillmentInput = "_ma-0";
export var shipDateInput = "_ma-1";
export var shipmentModal = "_ma-2";
export var shipmentModalContent = "_ma-3";
export var tableContainer = "_ma-4";